import { render, staticRenderFns } from "./PuInfo.vue?vue&type=template&id=055a85a7&scoped=true&"
import script from "./PuInfo.vue?vue&type=script&lang=js&"
export * from "./PuInfo.vue?vue&type=script&lang=js&"
import style0 from "./PuInfo.vue?vue&type=style&index=0&id=055a85a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055a85a7",
  null
  
)

export default component.exports